export default __webpack_public_path__ + "static/media/Kaspro.221dff99.svg";